type SettingsUser = {
    _auth?: { type?: string }
    accountAccessRole?: 'manager' | 'member'
}

export function canAccessAccountSettings(user?: SettingsUser) {
    return !!user && (user._auth?.type !== 'email' || user.accountAccessRole === 'manager')
}

export function settingsRedirect(user: SettingsUser | undefined, pathname: string) {
    if (canAccessAccountSettings(user)) return null
    const path = pathname.toLowerCase().replace(/\/+$/, '')
    if (path === '/network-settings') return '/'
    if (path === '/link-script/settings') return '/link-script'
    if (['/user-settings', '/user-settings/api', '/user-settings/account', '/user-settings/access'].includes(path)) {
        return '/user-settings/security'
    }
    return null
}
